import React, { useEffect } from "react";
import { array, object, string } from "yup";
import { Heading } from "@hopper/heading";
import { useFormikContext } from "formik";

import { RadioGroup } from "components/flexible_testing/shared/form";
import { RequestedTest } from "./requested_test_form";
import RequestedTestWizardNavigation from "./requested_test_wizard_navigation";

export const validations = () =>
  object().shape({
    requiresTestData: string().required(
      "Please specify whether testers need to use particular test data during the test.",
    ),
    testDataPool: array().when("requiresTestData", {
      is: "true",
      then: array().required().min(1, "Please provide test data."),
    }),
  });

const TestDataContent = ({ nextStep }: { nextStep: () => unknown }) => {
  const { values, isValid, validateForm } = useFormikContext<RequestedTest>();

  useEffect(() => {
    validateForm();
  }, []);

  return (
    <>
      <div className="grid grid-cols-2">
        <section className="flex flex-col gap-2xl">
          <div className="inline-block rounded-sm bg-light p-md px-lg text-sm border-l-4 border-primary w-full">
            You can now provide unique test data for each individual tester to use during your test
          </div>

          <section className="flex flex-col text-sm">
            <Heading size={5}>Test data</Heading>
            <p className="mb-lg mt-xs">
              Test data can be uploaded as a CSV with column headers. For example, if testers need to use pre-defined
              user accounts, we recommend that you provide unique accounts for each tester to avoid false negatives and
              bugs that may arise from multiple testers sharing a single account.
            </p>
            <p>
              You can do this by creating two columns in a CSV, with the headers being “account” and “password”. We’ll
              use the column headers as labels to be shown to the tester with the test data.
            </p>
          </section>

          <section>
            <RadioGroup
              name="requiresTestData"
              label="Do you need to provide any test data for testers to use in this test?"
              options={[
                { label: "Yes", value: "true" },
                { label: "No", value: "false" },
              ]}
              required
            />

            {values.requiresTestData === "true" && <span>HERE GOES THE UPLOADER</span>}
          </section>
        </section>
      </div>
      <RequestedTestWizardNavigation onSubmit={nextStep} submitDisabled={!isValid} />
    </>
  );
};

export default TestDataContent;
